const namespaced = true

function parsePersonalIds(input) {
    if (!input) return [];
    const ids = String(input).split(/[\s,]+/).map(s => parseInt(s, 10)).filter(n => !isNaN(n));
    return [...new Set(ids)].slice(0, 10);
}

const state = {
    isPricesConverted: false,
    storedFiltersApplied: false,
    paginator: null,
    numbering: null,
    page: 1,
    totalPropertiesNumber: null,
    selectedPropertyTypes: [],
    selectedDistricts: [],
    selectedBuilders: [],
    selectedComplexes: [],
    selectedBedroomsNumbers: [],
    selectedBathroomsNumbers: [],
    selectedPersonalId: '',
    selectedIsFinished: null,
    selectedMaxPrice: 30000000,
    selectedMinPrice: 100000,
    selectedHighestPrice: false,
    selectedLowestPrice: false,
    selectedIsNew: true,
    selectedIsPopular: false,
    selectedFurnitureType: null,
    selectedTagsIds: [],
    selectedConvenienceGroupIds: [],
    selectedStandaloneConvenienceIds: [],
    selectedPricePerMeter: false,
    default: {
        selectedPropertyTypes: [],
        selectedDistricts: [],
        selectedBuilders: [],
        selectedComplexes: [],
        selectedBedroomsNumbers: [],
        selectedBathroomsNumbers: [],
        selectedPersonalId: '',
        selectedIsFinished: null,
        selectedMaxPrice: 30000000,
        selectedMinPrice: 100000,
        selectedHighestPrice: false,
        selectedLowestPrice: false,
        selectedIsNew: true,
        selectedIsPopular: false,
        selectedFurnitureType: null,
        selectedTagsIds: [],
        selectedConvenienceGroupIds: [],
        selectedStandaloneConvenienceIds: [],
        selectedPricePerMeter: false,
    }
}

const getters = {
    storedFiltersApplied: (state) => state.storedFiltersApplied,
    paginator: (state) => state.paginator,
    numbering: (state) => state.numbering,
    page: (state) => state.page,
    totalPropertiesNumber: (state) => state.totalPropertiesNumber,
    selectedPropertyTypes: (state) => state.selectedPropertyTypes,
    selectedDistricts: (state) => state.selectedDistricts,
    selectedBuilders: (state) => state.selectedBuilders,
    selectedComplexes: (state) => state.selectedComplexes,
    selectedBedroomsNumbers: (state) => state.selectedBedroomsNumbers,
    selectedBathroomsNumbers: (state) => state.selectedBathroomsNumbers,
    selectedPersonalId: (state) => state.selectedPersonalId,
    selectedIsFinished: (state) => state.selectedIsFinished,
    selectedMaxPrice: (state) => state.selectedMaxPrice,
    selectedMinPrice: (state) => state.selectedMinPrice,
    selectedHighestPrice: (state) => state.selectedHighestPrice,
    selectedLowestPrice: (state) => state.selectedLowestPrice,
    selectedIsNew: (state) => state.selectedIsNew,
    selectedIsPopular: (state) => state.selectedIsPopular,
    selectedFurnitureType: (state) => state.selectedFurnitureType,
    selectedTagsIds: (state) => state.selectedTagsIds,
    selectedConvenienceGroupIds: (state) => state.selectedConvenienceGroupIds,
    selectedStandaloneConvenienceIds: (state) => state.selectedStandaloneConvenienceIds,
    selectedPricePerMeter: (state) => state.selectedPricePerMeter,
    defaultMaxPrice: (state) => state.default.selectedMaxPrice,
    defaultMinPrice: (state) => state.default.selectedMinPrice,
    isPricesConverted: (state) => state.isPricesConverted,
}

const mutations = {
    setStoredFiltersApplied(state, val) {
        state.storedFiltersApplied = val;
    },
    setPaginator(state, payload) {
        state.paginator = payload;
    },
    setTotalPropertiesNumber(state, payload) {
        state.totalPropertiesNumber = payload;
    },
    setNumbering(state, payload) {
        state.numbering = payload;
    },
    setPage(state, payload) {
        state.page = payload;
    },
    setSelectedPropertyTypes(state, payload) {
        state.selectedPropertyTypes = payload.selectedPropertyTypes;
    },
    setSelectedDistricts(state, payload) {
        state.selectedDistricts = payload.selectedDistricts;
    },
    setSelectedBuilders(state, payload) {
        state.selectedBuilders = payload.selectedBuilders;
    },
    setSelectedComplexes(state, payload) {
        state.selectedComplexes = payload.selectedComplexes;
    },
    setSelectedBedroomsNumbers(state, payload) {
        state.selectedBedroomsNumbers = payload.selectedBedroomsNumbers;
    },
    setSelectedBathroomsNumbers(state, payload) {
        state.selectedBathroomsNumbers = payload.selectedBathroomsNumbers;
    },
    setSelectedPersonalId(state, payload) {
        state.selectedPersonalId = payload.selectedPersonalId;
    },
    setSelectedIsFinished(state, payload) {
        state.selectedIsFinished = payload.selectedIsFinished;
    },
    setSelectedMaxPrice(state, payload) {
        state.selectedMaxPrice = payload.selectedMaxPrice;
    },
    setSelectedMinPrice(state, payload) {
        state.selectedMinPrice = payload.selectedMinPrice;
    },
    setSelectedHighestPrice(state, payload) {
        state.selectedHighestPrice = payload.selectedHighestPrice;
    },
    setSelectedLowestPrice(state, payload) {
        state.selectedLowestPrice = payload.selectedLowestPrice;
    },
    setSelectedIsNew(state, payload) {
        state.selectedIsNew = payload.selectedIsNew;
    },
    setSelectedIsPopular(state, payload) {
        state.selectedIsPopular = payload.selectedIsPopular;
    },
    setSelectedFurnitureType(state, payload) {
        state.selectedFurnitureType = payload.selectedFurnitureType;
    },
    setSelectedTagsIds(state, payload) {
        state.selectedTagsIds = payload.selectedTagsIds;
    },
    setSelectedConvenienceGroupIds(state, payload) {
        state.selectedConvenienceGroupIds = payload.selectedConvenienceGroupIds;
    },
    setSelectedStandaloneConvenienceIds(state, payload) {
        state.selectedStandaloneConvenienceIds = payload.selectedStandaloneConvenienceIds;
    },
    setSelectedPricePerMeter(state, payload) {
        state.selectedPricePerMeter = payload.selectedPricePerMeter;
    },
}

const actions = {
    convertSelectedPrices({ commit, state }) {
        if (!state.isPricesConverted)
        {
            axios.get('/api/v1/currencies/convert', {
                params: {
                    filtrationBaseMaxPrice: state.default.selectedMaxPrice,
                    filtrationBaseMinPrice: state.default.selectedMinPrice,
                    currency : window.currentCurrency
                }
            }).then(response => {
                // округлим цены для фильтрации
                let magnitude = Math.pow(10, Math.floor(Math.log10(response.data.maxPrice)));
                response.data.maxPrice = Math.ceil(response.data.maxPrice / magnitude) * magnitude;

                magnitude = Math.pow(10, Math.floor(Math.log10(response.data.minPrice)));
                response.data.minPrice = Math.floor(response.data.minPrice / magnitude) * magnitude;

                state.default.selectedMaxPrice = response.data.maxPrice;
                state.default.selectedMinPrice = response.data.minPrice;
                state.selectedMaxPrice = state.default.selectedMaxPrice;
                state.selectedMinPrice = state.default.selectedMinPrice;
                state.isPricesConverted = true;
            }).catch(error => {
                console.error('Filtration error: ', error);
            });
        }
    },
    initializePriceRange({ state }, priceRange) {
        if (priceRange && !state.isPricesConverted) {
            state.default.selectedMinPrice = priceRange.min || state.default.selectedMinPrice;
            state.default.selectedMaxPrice = priceRange.max || state.default.selectedMaxPrice;
            state.selectedMinPrice = state.default.selectedMinPrice;
            state.selectedMaxPrice = state.default.selectedMaxPrice;
        }
    },
    resetFiltrationParams({ state, dispatch }){
        dispatch('updateSelectedFilters', state.default);
    },
    extractFromLocalStorageToState({ state, dispatch }){
        let queryParams = window.localStorage.getItem('filtration');
        if (!!queryParams && queryParams !== 'null') {
            queryParams = JSON.parse(queryParams);
            dispatch('updateSelectedFilters', queryParams);
            state.default = queryParams.default;
            state.isPricesConverted = queryParams.isPricesConverted;
        }
    },
    saveToLocalStorage({ state }){
        const queryParamsLocalStorage = {
            isPricesConverted: state.isPricesConverted,
            selectedPropertyTypes: state.selectedPropertyTypes,
            selectedDistricts: state.selectedDistricts,
            selectedBuilders: state.selectedBuilders,
            selectedComplexes: state.selectedComplexes,
            selectedBedroomsNumbers: state.selectedBedroomsNumbers,
            selectedBathroomsNumbers: state.selectedBathroomsNumbers,
            selectedPersonalId: state.selectedPersonalId,
            selectedIsFinished: state.selectedIsFinished,
            selectedMaxPrice: state.selectedMaxPrice,
            selectedMinPrice: state.selectedMinPrice,
            selectedHighestPrice: state.selectedHighestPrice,
            selectedLowestPrice: state.selectedLowestPrice,
            selectedIsNew: state.selectedIsNew,
            selectedIsPopular: state.selectedIsPopular,
            selectedFurnitureType: state.selectedFurnitureType,
            selectedTagsIds: state.selectedTagsIds,
            selectedConvenienceGroupIds: state.selectedConvenienceGroupIds,
            selectedStandaloneConvenienceIds: state.selectedStandaloneConvenienceIds,
            selectedPricePerMeter: state.selectedPricePerMeter,
            default: state.default
        }
        window.localStorage.setItem('filtration', JSON.stringify(queryParamsLocalStorage));
    },
    buildQueryParams({ state }) {
        return {
            propertyTypesIds:             JSON.stringify(state.selectedPropertyTypes.map(t => t.id)),
            districtsIds:                 JSON.stringify(state.selectedDistricts.map(t => t.id)),
            buildersIds:                  JSON.stringify(state.selectedBuilders.map(t => t.id)),
            complexesIds:                 JSON.stringify(state.selectedComplexes.map(t => t.id)),
            bedroomsNumbers:              JSON.stringify(state.selectedBedroomsNumbers),
            bathroomsNumbers:             JSON.stringify(state.selectedBathroomsNumbers),
            personalIds:                  JSON.stringify(parsePersonalIds(state.selectedPersonalId)),
            isFinished:                   state.selectedIsFinished,
            maxPrice:                     (!state.selectedPricePerMeter && state.selectedMaxPrice !== state.default.selectedMaxPrice) ? state.selectedMaxPrice : null,
            minPrice:                     (!state.selectedPricePerMeter && state.selectedMinPrice !== state.default.selectedMinPrice) ? state.selectedMinPrice : null,
            maxPricePerMeter:             (state.selectedPricePerMeter && state.selectedMaxPrice !== state.default.selectedMaxPrice) ? state.selectedMaxPrice : null,
            minPricePerMeter:             (state.selectedPricePerMeter && state.selectedMinPrice !== state.default.selectedMinPrice) ? state.selectedMinPrice : null,
            highestPrice:                 state.selectedHighestPrice,
            lowestPrice:                  state.selectedLowestPrice,
            isNew:                        state.selectedIsNew,
            isPopular:                    state.selectedIsPopular,
            furnitureType:                state.selectedFurnitureType,
            tagsIds:                      JSON.stringify(state.selectedTagsIds),
            convenienceGroupIds:          JSON.stringify(state.selectedConvenienceGroupIds),
            standaloneConvenienceIds:     JSON.stringify(state.selectedStandaloneConvenienceIds),
            pricePerMeter:                state.selectedPricePerMeter || null,
            currency:                     window.currentCurrency,
            measurementUnitSystem:        window.measurementUnitSystem || 'metric',
        };
    },
    redirectToPropertiesPage({ state, dispatch }) {
        const currentPath = window.location.pathname;
        const isComplexesPage = window.complexesUrl
            ? window.location.href.startsWith(window.complexesUrl)
            : currentPath.includes('/complexes');

        const queryParamsURL = {
            propertyTypesIds:             JSON.stringify(state.selectedPropertyTypes.map(t => t.id)),
            districtsIds:                 JSON.stringify(state.selectedDistricts.map(t => t.id)),
            buildersIds:                  JSON.stringify(state.selectedBuilders.map(t => t.id)),
            complexesIds:                 JSON.stringify(state.selectedComplexes.map(t => t.id)),
            bedroomsNumbers:              JSON.stringify(state.selectedBedroomsNumbers),
            bathroomsNumbers:             JSON.stringify(state.selectedBathroomsNumbers),
            personalIds:                  JSON.stringify(parsePersonalIds(state.selectedPersonalId)),
            isFinished:                   state.selectedIsFinished,
            maxPrice:                     (!state.selectedPricePerMeter && state.selectedMaxPrice !== state.default.selectedMaxPrice) ? state.selectedMaxPrice : null,
            minPrice:                     (!state.selectedPricePerMeter && state.selectedMinPrice !== state.default.selectedMinPrice) ? state.selectedMinPrice : null,
            maxPricePerMeter:             (state.selectedPricePerMeter && state.selectedMaxPrice !== state.default.selectedMaxPrice) ? state.selectedMaxPrice : null,
            minPricePerMeter:             (state.selectedPricePerMeter && state.selectedMinPrice !== state.default.selectedMinPrice) ? state.selectedMinPrice : null,
            highestPrice:                 state.selectedHighestPrice,
            lowestPrice:                  state.selectedLowestPrice,
            isNew:                        state.selectedIsNew,
            isPopular:                    state.selectedIsPopular,
            furnitureType:                state.selectedFurnitureType,
            tagsIds:                      JSON.stringify(state.selectedTagsIds),
            convenienceGroupIds:          JSON.stringify(state.selectedConvenienceGroupIds),
            standaloneConvenienceIds:     JSON.stringify(state.selectedStandaloneConvenienceIds),
            pricePerMeter:                state.selectedPricePerMeter || null,
            currency:                     window.currentCurrency,
            measurementUnitSystem:        window.measurementUnitSystem || 'metric',
        }

        dispatch('saveToLocalStorage');

        if (isComplexesPage) {
            const targetUrl = window.complexesUrl || currentPath;

            window.location.href = targetUrl + '?' + new URLSearchParams(queryParamsURL).toString();

            return;
        }

        // Off the complexes catalog the button is navigation, nothing more: it opens
        // the MLS catalog, which filters through its own in-page facets and ignores
        // these parameters. Sending them would only put a query string on the URL
        // that changes none of the listings below it. Wiring this popup to the MLS
        // filters is a separate task; until then the selection stays in local
        // storage, so nothing the visitor picked is lost.
        window.location.href = window.propertiesUrl || '/real-estate';
    },
    updateSelectedPropertyTypes({ commit, dispatch }, params) {
        commit('setSelectedPropertyTypes', params);
    },
    updateSelectedFilters({ commit, dispatch }, params) {
        commit('setSelectedPropertyTypes', params);
        commit('setSelectedDistricts', params);
        commit('setSelectedBuilders', params);
        commit('setSelectedComplexes', params);
        commit('setSelectedBedroomsNumbers', params);
        commit('setSelectedBathroomsNumbers', params);
        commit('setSelectedPersonalId', params);
        commit('setSelectedIsFinished', params);
        commit('setSelectedMaxPrice', params);
        commit('setSelectedMinPrice', params);
        commit('setSelectedHighestPrice', params);
        commit('setSelectedLowestPrice', params);
        commit('setSelectedIsNew', params);
        commit('setSelectedIsPopular', params);
        if (params.selectedFurnitureType !== undefined) commit('setSelectedFurnitureType', params);
        if (params.selectedTagsIds !== undefined) commit('setSelectedTagsIds', params);
        if (params.selectedConvenienceGroupIds !== undefined) commit('setSelectedConvenienceGroupIds', params);
        if (params.selectedStandaloneConvenienceIds !== undefined) commit('setSelectedStandaloneConvenienceIds', params);
        if (params.selectedPricePerMeter !== undefined) commit('setSelectedPricePerMeter', params);
    },
    setSelectedMinPrice({ commit }, payload) {
        commit('setSelectedMinPrice', payload)
    },
    setSelectedMaxPrice({ commit }, payload) {
        commit('setSelectedMaxPrice', payload)
    },
    setSelectedPropertyTypes({ commit }, payload) {
        commit('setSelectedPropertyTypes', payload)
    },
    setSelectedDistricts({ commit }, payload) {
        commit('setSelectedDistricts', payload)
    },
    setSelectedIsNew({ commit }, payload) {
        commit('setSelectedIsNew', payload)
    },
    setSelectedIsPopular({ commit }, payload) {
        commit('setSelectedIsPopular', payload)
    },
    setSelectedLowestPrice({ commit }, payload) {
        commit('setSelectedLowestPrice', payload)
    },
    setSelectedHighestPrice({ commit }, payload) {
        commit('setSelectedHighestPrice', payload)
    },
    setSelectedBuilders({ commit }, payload) {
        commit('setSelectedBuilders', payload)
    },
    setSelectedComplexes({ commit }, payload) {
        commit('setSelectedComplexes', payload)
    },
    setSelectedBedroomsNumbers({ commit }, payload) {
        commit('setSelectedBedroomsNumbers', payload)
    },
    setSelectedBathroomsNumbers({ commit }, payload) {
        commit('setSelectedBathroomsNumbers', payload)
    },
    setSelectedPersonalId({ commit }, payload) {
        commit('setSelectedPersonalId', payload)
    },
    setSelectedIsFinished({ commit }, payload) {
        commit('setSelectedIsFinished', payload)
    },
    setSelectedFurnitureType({ commit }, payload) {
        commit('setSelectedFurnitureType', payload)
    },
    setSelectedTagsIds({ commit }, payload) {
        commit('setSelectedTagsIds', payload)
    },
    setSelectedConvenienceGroupIds({ commit }, payload) {
        commit('setSelectedConvenienceGroupIds', payload)
    },
    setSelectedStandaloneConvenienceIds({ commit }, payload) {
        commit('setSelectedStandaloneConvenienceIds', payload)
    },
    setSelectedPricePerMeter({ commit }, payload) {
        commit('setSelectedPricePerMeter', payload)
    },
}

export default {
    mutations,
    actions,
    state,
    getters,
    namespaced,
}
